import { render, staticRenderFns } from "./ModalDownloadCertificate.vue?vue&type=template&id=56358c13&"
import script from "./ModalDownloadCertificate.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports